class TimerCountDown {
  private timeLeft = 0;

  private timer: number | undefined = undefined;

  get time(): number {
    return this.timeLeft;
  }

  start(timeLeft: number) {
    this.timeLeft = timeLeft;
    this.stop();
    this.timer = window.setInterval(() => {
      if (this.timer != null && this.timeLeft <= 0) {
        this.stop();
        return;
      }
      this.timeLeft -= 1;
    }, 1000);
  }

  stop() {
    clearInterval(this.timer);
  }
}

export default TimerCountDown;
